import { CENTRIFUGE_ENDPOINT, CENTRIFUGE_TOKEN } from "./configs";
import Centrifuge from "centrifuge";

const API = {
  TEST: "_test",
  PROD: "_prod",
};

const centrifuge = new Centrifuge(CENTRIFUGE_ENDPOINT);

const CENTRIFUGE_OBJ = {
  env: API.PROD,
  centrifuge,
};

export default CENTRIFUGE_OBJ;
